import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_DispatchPartsOrderedBus } from '@app/cp/shared/models/v_DispatchPartsOrderedBus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';

@Component({
    selector: 'job-parts-ordered',
    templateUrl: './job-parts-ordered.component.html',
    styleUrls: ['./job-parts-ordered.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class JobPartsOrderedComponent extends BaseGridUIComponent<v_DispatchPartsOrderedBus, null, DispatchesService>  {

  constructor(globals: GlobalsService, svc_data: DispatchesService) {
    super(globals);
    this.svc_data = svc_data;
  }
}
